import Accounting from '../assets/accounting.jpg'
import Analytical from '../assets/analytical.jpg'
import AppliedMath from '../assets/appliedMath.jpg'
import Business from '../assets/busMan.jpg'
import CompSci from '../assets/compSci.jpg'
import Economics from '../assets/economics.jpg'
import FinMan from '../assets/finMan.jpg'
import HR from '../assets/humanRes.jpg'
import Industrial from '../assets/industrial.jpg'
import Marketing from '../assets/marketing.jpg'
import Psychology from '../assets/psychology.jpg'
import HealthPsych from '../assets/HealthPsych.jpg'
import ReseatchModules from '../assets/ResearchModules.jpg'
import Economics2C from '../assets/Economics2C.jpg';
import Economics2D from '../assets/economics2D.jpg'
import tax200 from '../assets/tax200.jpg';
import AccStudies from '../assets/AccountingStudies.jpg';
import BasicMath from '../assets/BasicMath.jpg';
import MAA from '../assets/MAA.jpg';
import FRAMA from '../assets/FRAMA.jpg';
import FRAMB from '../assets/FRAMB.jpg';
import CommLaw from '../assets/CommLaw.jpg';
import ManAcc from '../assets/ManAcc.jpg';
import GovControl from '../assets/GovControl.jpg';



const moduleData = [

    
    {
        name:'Accounting A/B & 1A/1B',
        picture:Accounting,
    },

    {
        name:'Analytical Techniques 1A/1B',
        picture:Analytical,
    },

    {
        name:'Applied Mathematics',
        picture:AppliedMath,
    },

    {
        name:'Accounting Studies 200',
        picture:AccStudies,
    },

    {
        name:'Basic Maths & Application in Economics & Business A/B',
        picture:BasicMath,
    },


    {
        name:'Business Management 1A/1B',
        picture:Business,
    },

    {
        name:'Commercial Law 1A/B',
        picture:CommLaw,
    },

    {
        name:'Computer Science 1A/1B',
        picture:CompSci,
    },

    {
        name:'Economics 1A/1B',
        picture:Economics,
    },

    {
        name:'Economics 2C',
        picture:Economics2C,
    },

    {
        name:'Economics 2D',
        picture:Economics2D,
    },


    {
        name:'Financial-Management 1A/1B',
        picture:FinMan,
    },

    {
        name:'Financial Reporting Analysis & Management A',
        picture:FRAMA,
    },

    {
        name:'Financial Reporting Analysis & Management B',
        picture:FRAMB,
    },

    {
        name:'Governance and Control',
        picture:GovControl
    },

    {
        name:'Human Resource Management 1A/1B',
        picture:HR,
    },

    {
        name:'Industrial Psychlogy 1A/1B',
        picture:Industrial,
    },

    {
        name:"Management Accounting",
        picture:ManAcc
    },

    {
        name:'Marketing 1A/1B',
        picture:Marketing,
    },

    {
        name:'Mathematical Analysis A',
        picture:MAA,
    },


    {
        name:'Psychology 1A/1B',
        picture:Psychology,
    },

    {
        name:'Psychology 2C',
        picture:HealthPsych,
    },

    {
        name:'Research Modules',
        picture:ReseatchModules,
    },

    {
        name:'Taxation 200/2A/2B',
        picture:tax200,
    },



];

export default moduleData;